<template>
  <div class="chart line_chart"></div>
</template>

<script>
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import ChartMixin from './ChartMixin'

export default {
  name: 'BarLineChart',
  mixins: [
    ChartMixin
  ],
  methods: {
    getDefaultOptions () {
      return {
        grid: {
          containLabel: true,
          right: 20,
          left: 5,
          top: 30,
          bottom: 0
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          splitLine: {
            show: false
          },
          axisTick: {
            // alignWithLabel: false
          }
        },
        yAxis: {
          type: 'value',
          offset: 4,
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#e6e6e6'
            }
          },
          axisTick: {
            show: false
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
.line_chart {
  position: relative;
  width: 600px;
  height: 400px;
}
</style>
